module.exports = __webpack_public_path__ + "media/Video 131a.b2aa95e3.mp4";